import { differenceInDays } from 'date-fns';

import { MAX_NIGHTS_PACKAGES_HOTELS } from '@shared/base-search-bar/components/calendar/constants/calendar.constants';

export function isOutOfRangeDate(maxDate: Date, minDate: Date): boolean {
  return differenceInDays(maxDate, minDate) > MAX_NIGHTS_PACKAGES_HOTELS;
}
